module.exports = __webpack_public_path__ + "static/img/6.ca925a1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/10/sp/6.png
// module id = /3g3
// module chunks = 0